<div id="{{toastId}}" class="toast hide" role="alert" aria-live="assertive" aria-atomic="true" data-delay="6000"
  [ngStyle]="toastId == 'fileDownloadToastSuccess' || toastId == 'fileDownloadToastError'?{'top': '30px', 'position':'fixed'} : {'top': '80px', 'position':'absolute'}"
  style="position:absolute;right:16px;z-index: 99999">
  <div class="toast-body p-0 d-flex">
    <div class="{{icon['bgIcon']}} p-3 toast-icon" [ngStyle]="{'color': icon['iconColor']}" [innerHTML]="icon['icon']">
    </div>
    <div class="align-items-center bg-white d-flex p-3 toast-content">{{content}}</div>
    <div class="align-items-center bg-white d-flex p-3"><button type="button" class="ms-2 mb-1 close"
        data-bs-dismiss="toast" aria-label="Close" (click)="closeToast()">
        <span aria-hidden="true">&times;</span>
      </button></div>
  </div>
</div>